import React from 'react';
import {
  PairwiseAffinityByRoundScenario,
  SimpleScenario,
} from '../../../src/components/rcv/scenarios';
import { Ballot, BallotSet } from '../../../src/components/rcv/ballot';

/*
NOTES:
SF Voting population: 500,000
Expected turnout: 80%
*/
const voterUniverse = 500000 * 0.8;
const Mayor0722 = new PairwiseAffinityByRoundScenario({
  name: 'San Francisco Mayoral Election 2024 RCV Simulation',
  notes:
    'GrowSF polled on the San Francisco Mayoral election for November 2024, and this is how the election would unfold if the election were held today.',
  firstRankVotes: {
    Breed: voterUniverse * 0.2394,
    Farrell: voterUniverse * 0.2085,
    Lurie: voterUniverse * 0.1582,
    Peskin: voterUniverse * 0.1326,
    Safai: voterUniverse * 0.0643,
    Other: voterUniverse * 0.0126,
  },
  // Each round of voting gets its own affinity matrix. If you input fewer than the max number of rounds, the last affinity matrix will be used for the remaining rounds.
  pairwiseAffinity: [
    {
      // 1st to 2nd
      Breed: {
        Breed: 0.3141,
        Farrell: 0.1902,
        Lurie: 0.2538,
        Peskin: 0.1498,
        Safai: 0.0899,
        Other: 0.0022,
      },
      Farrell: {
        Breed: 0.0991,
        Farrell: 0.0926,
        Lurie: 0.7072,
        Peskin: 0.0453,
        Safai: 0.0453,
        Other: 0.0105,
      },
      Lurie: {
        Breed: 0.1776,
        Farrell: 0.4626,
        Lurie: 0.1576,
        Peskin: 0.0707,
        Safai: 0.1113,
        Other: 0.0201,
      },
      Peskin: {
        Breed: 0.2016,
        Farrell: 0.0406,
        Lurie: 0.0727,
        Peskin: 0.183,
        Safai: 0.4843,
        Other: 0.0137,
      },
      Safai: {
        Breed: 0.2928,
        Farrell: 0.1314,
        Lurie: 0.099,
        Peskin: 0.2923,
        Safai: 0.1845,
        Other: 0,
      },
      Other: {
        Breed: 0.07,
        Farrell: 0.0,
        Lurie: 0.0,
        Peskin: 0.0,
        Safai: 0.1375,
        Other: 0.7925,
      },
    },
    {
      // 2nd to 3rd
      Breed: {
        Breed: 0.2654,
        Farrell: 0.1474,
        Lurie: 0.3205,
        Peskin: 0.0761,
        Safai: 0.1669,
        Other: 0.0237,
      },
      Farrell: {
        Breed: 0.1536,
        Farrell: 0.326,
        Lurie: 0.2298,
        Peskin: 0.0767,
        Safai: 0.1783,
        Other: 0.0357,
      },
      Lurie: {
        Breed: 0.3127,
        Farrell: 0.1102,
        Lurie: 0.198,
        Peskin: 0.0823,
        Safai: 0.2164,
        Other: 0.0804,
      },
      Peskin: {
        Breed: 0.1406,
        Farrell: 0.1237,
        Lurie: 0.2857,
        Peskin: 0.3544,
        Safai: 0.0878,
        Other: 0.0078,
      },
      Safai: {
        Breed: 0.1507,
        Farrell: 0.2457,
        Lurie: 0.1786,
        Peskin: 0.0683,
        Safai: 0.2968,
        Other: 0.06,
      },
      Other: {
        Breed: 0.0,
        Farrell: 0.0,
        Lurie: 0.05,
        Peskin: 0.0,
        Safai: 0.0,
        Other: 0.95,
      },
    },
  ],
  maxRankings: 3,
});

const weightSum = 858.85604; // sum of WTS column for every row with mayoral rankings
const normalizer = 888 / weightSum; // 888 is the number of valid ballots
const SCALE_FACTOR = (voterUniverse / 1067) * normalizer; // 1067 is the number of people who answered the question
const bs = new BallotSet(
  [
    new Ballot(Math.round(SCALE_FACTOR * 1.34326156607349), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.49780762021745), ['Peskin', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.33412346485194), ['Peskin', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.80477228540938), ['Peskin', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.88182300336594), ['Lurie', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56271013879111), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56271013879111), ['Peskin', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.61742820063673), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60704706674033), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60704706674033), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60704706674033), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.96136169168942), ['Peskin', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.58266343685731), ['Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.58266343685731), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.58266343685731), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.41179801367684), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.41615202422011), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.55556591138747), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51879900058508), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.65075546338525), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.6302120597902), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.61026878258579), ['Farrell', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.5473692712614), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.0327404550441), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.48040091588814), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.48040091588814), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36676131303272), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36676131303272), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.46592397468327), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33311399149496), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.59351988239782), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.46034636598066), ['Lurie', 'Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43723241979408), ['Peskin', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43723241979408), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43723241979408), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.46521368652245), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.44185535264566), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.73674454778907), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.3514506988913), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33733376425242), ['Farrell', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.55424120793584), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.88701512226972), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 4.84258040731225), ['Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 3.69142422268024), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.77699974342755), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 2.07544330775733), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 2.47261901190491), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 2.34846905221239), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.94215252917947), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 2.2208798582993), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.26570430037922), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.3494958600705), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.3494958600705), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.45696549798578), ['Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.94987693127342), ['Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.72213265852752), ['Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.42903479736083), ['Peskin', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.5165431551289), ['Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56677192898571), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.57276450513342), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.55724250471022), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52926341283814), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52926341283814), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52926341283814), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.8824877449554), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56313432463185), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.53485940505552), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.53485940505552), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.53485940505552), ['Peskin', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.6709008297825), ['Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.63721496448172), ['Breed', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43683317466032), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.49616439996043), ['Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.4712520337773), ['Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.78576023678582), ['Safai', 'Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.59736489020179), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.57337017021078), ['Lurie', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33597442191849), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33952673671049), ['Lurie', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.4642993333859), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33667075240573), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.89463186940928), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30578399129976), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.62034518062185), ['Peskin', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.4013601285562), ['Lurie', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.42704570058343), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.42704570058343), ['Lurie', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40560377756212), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40560377756212), ['Peskin', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30641775000805), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30641775000805), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 3.71395462253292), ['Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 3.71395462253292), ['Lurie', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 2.20181716095532), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.09126413581608), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 4.15424426637751), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 2.71619288743315), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 2.94254985403485), ['Lurie', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 2.38279562953355), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 2.72476169640005), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 4.5432364049171), ['Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.64428373669626), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.94197600274085), ['Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.04307614908563), ['Peskin', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.71805375259242), ['Lurie', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.9793211221141), ['Peskin', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.72194235574268), ['Lurie', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.66711130254793), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.66711130254793), ['Lurie', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.66711130254793), ['Lurie', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.67416478398388), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.67416478398388), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.67416478398388), ['Safai', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.64031503586064), ['Lurie', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.80317908747725), ['Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.28541867021479), ['Lurie', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.64281186864839), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.22563859315448), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.94493812958858), ['Peskin', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56416650816151), ['Peskin', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.95063078609072), ['Lurie', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.45348127130602), ['Lurie', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.72575755745882), ['Farrell', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51524584535879), ['Peskin', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.66520838608444), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.67224174766048), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.55584297760681), ['Peskin', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52793415585425), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.53351609361111), ['Safai', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40305048927303), ['Farrell', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.0510127469769), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.48049435548921), ['Safai', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.48557470415603), ['Breed', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.48557470415603), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.57849869505406), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 3.0994586450471), ['Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 3.81748936234796), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.84145613136728), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 3.11624369018852), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.39173520019657), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 3.78771717073076), ['Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 2.04404221601634), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 3.4082125498396), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 2.13404404789916), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.89275567528245), ['Peskin', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.72267395130324), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.72267395130324), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 2.87236679071923), ['Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.31517268059155), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.55557748853069), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.02719036208466), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60568947759324), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.18142584092456), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43325107941018), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.68612635403146), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52161941385216), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.16111205963675), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56271873084432), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56866845183767), ['Breed', 'Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.38576339749881), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.53654876002265), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.78873058581654), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.50104038919475), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47588320006721), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.5063379745757), ['Breed', 'Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.5063379745757), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.57294702235729), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60961352449215), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.61507500505491), ['Farrell', 'Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.58419214897487), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.41279574169625), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.50739878092377), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56111359129241), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.46886217294326), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.44532064891874), ['Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.74252254305466), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.74252254305466), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47381953256262), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47381953256262), ['Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.45002909999458), ['Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.45002909999458), ['Breed', 'Safai', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.45002909999458), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56449394693041), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51487130834181), ['Breed', 'Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.31205392169358), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.55017934070116), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40530444150183), ['Peskin', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40530444150183), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40530444150183), ['Breed', 'Safai', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40530444150183), ['Lurie', 'Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40530444150183), ['Farrell', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40530444150183), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40530444150183), ['Breed', 'Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43124243505042), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43124243505042), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40958979440039), ['Farrell', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40958979440039), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40958979440039), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.68294532599344), ['Safai', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.68294532599344), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 2.72234861939369), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.5269623944437), ['Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.90702663302077), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.36182993365482), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.60217704459742), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.45195766344004), ['Safai', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 3.12125656993388), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.96789737770822), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.86908944209615), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.88885164314356), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 3.14944956836231), ['Farrell', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.70113434956388), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.70113434956388), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.33134205165933), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.64082923968466), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.72593275275101), ['Lurie', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56547225275361), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.94286194938623), ['Safai', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.94286194938623), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.69542117347568), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.53010881571662), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.53010881571662), ['Lurie', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.50881561150172), ['Breed', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.50881561150172), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.84839331550312), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.62461983418026), ['Farrell', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.74415276554862), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.49606374374874), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.49606374374874), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47115643150419), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.50130871020968), ['Peskin', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47613804871012), ['Safai', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.3787190739819), ['Farrell', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.45695807398322), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.48348441106505), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.4514877967091), ['Peskin', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.4288186384226), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.4288186384226), ['Lurie', 'Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43335261093056), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.34833207942276), ['Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51628290719412), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51628290719412), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.86084419870543), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 4.30671013496723), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 4.42668707166168), ['Safai', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 5.61132312857136), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 6.7177550190939), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 6.78878298719674), ['Safai', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 4.90195374926066), ['Peskin', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 4.90195374926066), ['Lurie', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.61444845147292), ['Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.62094511961399), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.98337160880104), ['Farrell', 'Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47405956121015), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.75075348633796), ['Farrell', 'Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.18394563004891), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36062086693563), ['Farrell', 'Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36062086693563), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.57110412963093), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43417513348128), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43417513348128), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.80273323123342), ['Safai', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.89306097505038), ['Breed', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.58299163665541), ['Peskin', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.58299163665541), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.9232658499865), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.69455821760479), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33857895454206), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33857895454206), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33857895454206), ['Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40337250210713), ['Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.63880857391999), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43975590285864), ['Safai', 'Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.4774256759721), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.2185992429937), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.41930447923319), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.44676406270349), ['Safai', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.44676406270349), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.44676406270349), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.53788858145457), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.39237557190564), ['Peskin', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47941748059722), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.34958468833204), ['Safai', 'Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.58026977496193), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.4199062280019), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.70014682907138), ['Safai', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52893347623338), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40236388917806), ['Peskin', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.25675701252937), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.48955428324734), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36089283129985), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.57153483119525), ['Safai', 'Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.39909806695568), ['Lurie', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.24181395562561), ['Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40319781647943), ['Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.63584692119724), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.79886892996539), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.37305971526281), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.25048999252031), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.49791593741752), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.31256987252393), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.44137148730535), ['Lurie', 'Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.19462324598497), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47420007325758), ['Lurie', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.38460848446242), ['Lurie', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60909257867983), ['Farrell', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.42668831065323), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33886948382652), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.38750221721285), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60462132666918), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.23595522694916), ['Peskin', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.45706492841083), ['Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.27701855020538), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.73908654823115), ['Farrell', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60402624137294), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.55554326776572), ['Lurie', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.45562249683226), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.45562249683226), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.72918440373942), ['Lurie', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52651973535669), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.53219330540202), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.64074245446259), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40568273388767), ['Breed', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.38531344334286), ['Lurie', 'Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.48842807304372), ['Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.77350845477484), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.49801436167187), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.78868996401442), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36056753548417), ['Peskin', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36056753548417), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36056753548417), ['Peskin', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60120617366548), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60120617366548), ['Safai', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51831303075156), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.34344643509301), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.3455154833414), ['Lurie', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.32816718458472), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.54718220014407), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.54718220014407), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.55296765075187), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.39510201498317), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.65878856873952), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.29271092150873), ['Breed', 'Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.29271092150873), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.32653517339802), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.23874612911567), ['Lurie', 'Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.34219967832477), ['Breed', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.32501786581493), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30414430871787), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30414430871787), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30414430871787), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.50712673241884), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.27681411019265), ['Safai', 'Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.46155667282154), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.2945291951242), ['Safai', 'Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.2945291951242), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.27974091293156), ['Safai', 'Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33327467781793), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.7362575244887), ['Breed', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.43627250925488), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.64583956426434), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.34403106845377), ['Safai', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.27654739944911), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 2.1285004943522), ['Farrell', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.1618377275803), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.1741220357786), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.09473903539798), ['Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.53906504298754), ['Breed', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.41794812739478), ['Peskin', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.41092095327516), ['Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.41092095327516), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.7834960796988), ['Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.7834960796988), ['Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.21281383678249), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.3620527808285), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.57337180744015), ['Breed', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.57337180744015), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.44445442084246), ['Safai', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.32178958578669), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.2928737947927), ['Lurie', 'Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.23541415322157), ['Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.39005168777659), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.29653216430853), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.29653216430853), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.61639021654544), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30034370830163), ['Lurie', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.25399638787957), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.23768402889106), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.24019710261504), ['Breed', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36069933387951), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.26044895755264), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 3.1329852206574), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.26579881986753), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.20224318444259), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.12875953061956), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.07626509181409), ['Breed', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.9404923228033), ['Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 7.53703880372081), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.10360635949857), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.43112822348564), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.9856082890482), ['Lurie', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.04666333886373), ['Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.30601969678121), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.16286979853938), ['Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.0227357205975), ['Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.04963512301643), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.78047056041283), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.96603131490231), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.82134069107772), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.10636636610333), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.55508777105857), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.65109412649591), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.12412243052613), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.94838465573118), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.03340512000083), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 4.29659487999917), ['Breed', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.64338797923437), ['Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.57373280970736), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.55692464870026), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.42518323479873), ['Lurie', 'Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.79707707970387), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51261656304591), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.85988019380579), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.49417643030362), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47432654413558), ['Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 3.34220278805495), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 2.87249139575501), ['Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 3.30175687616554), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.97362265392436), ['Farrell', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.00901328727741), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.15262450693129), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.01555032582169), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.62102043214804), ['Peskin', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.94463799291225), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.34998655004382), ['Peskin', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 2.76235447313654), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 3.09263198539846), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.01775140921737), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.73686251963722), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.59669092401309), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.94496098828911), ['Lurie', 'Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51085503966063), ['Farrell', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.41497076457114), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43508956926574), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43508956926574), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.72546335817163), ['Farrell', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.55735627093455), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52937146687143), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52937146687143), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.75295628083756), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 3.34552441212296), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.74144792185953), ['Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.90121162015417), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.35071268984509), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.46033178415976), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 5.95806705285118), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.27095176234262), ['Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43759400323953), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.44837007961952), ['Lurie', 'Safai', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.66566358335684), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.66566358335684), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52553078727938), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.34361074963465), ['Peskin', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43740449755252), ['Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.59559210130487), ['Breed', 'Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.53850415353656), ['Peskin', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.97522035546639), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.20402606385882), ['Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.43944370782524), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.86692140539138), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.21631899508097), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.21631899508097), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36633037982467), ['Breed', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.3785409059711), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.48360925104455), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.68695215166127), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.87580677440119), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.57588089999593), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.81802120720058), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.81802120720058), ['Peskin', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.81802120720058), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.3563733184171), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.73912621361789), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.94232435761152), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51395203672191), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.73005315079112), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.93075695823873), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.75438728625181), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.61961909294484), ['Breed', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.12779392561883), ['Breed', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.25992639267799), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56940460926306), ['Breed', 'Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56940460926306), ['Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.80882183426857), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56241494538899), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56241494538899), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.79889323048916), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.0185223258907), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.82552194384829), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.96314337421977), ['Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 4.91159101504569), ['Breed', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 3.26836749974854), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.62988883618398), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 2.31520724751834), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 2.39237774766567), ['Breed', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.9341429872338), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.91040062697675), ['Lurie', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.52200600138449), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.75367900252355), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 2.49104739312722), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.49104739312722), ['Breed', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 4.18986725701415), ['Peskin', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.67647227670208), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56709548487095), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56709548487095), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.4026889473483), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.72926170726133), ['Peskin', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.39774578330997), ['Farrell', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.72030973510118), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47363485948086), ['Breed', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.74125606169984), ['Peskin', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.23969371639475), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52508214160324), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51863655332317), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40182241359598), ['Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40182241359598), ['Farrell', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40182241359598), ['Peskin', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.26421564658301), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.58016415696784), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.29291534348834), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.41607728766416), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.53046388504571), ['Lurie', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.21585032285623), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.17161587268065), ['Breed', 'Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.20689960106698), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.31516228345679), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.31516228345679), ['Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.5707526526654), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.37068771025796), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.37570143153506), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33552033926864), ['Farrell', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.28476667494263), ['Farrell', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.34488038916933), ['Breed', 'Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.6245715534602), ['Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.34064684775109), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.34064684775109), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.41068285703138), ['Peskin', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.58336243915672), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.74373851935554), ['Peskin', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 2.31299072357008), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 2.31299072357008), ['Peskin', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 6.11602324054618), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.86514051484007), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 2.82996979647054), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.41799963429705), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.812211810628), ['Lurie', 'Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.14394338265867), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.66633599981081), ['Breed', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.12525123301068), ['Breed', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.12525123301068), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.96097189813483), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.94917559292213), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.3410932087192), ['Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.3410932087192), ['Breed', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.57695645350402), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.88977816920547), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.88977816920547), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.88977816920547), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.26390267869506), ['Safai', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.68937063773129), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.34417491140428), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.58216912912021), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.89889780487382), ['Farrell', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.49026681087895), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.05726600718154), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.74172838386701), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.29081175096557), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.75861360104241), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.86316383756764), ['Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.32218872500987), ['Breed', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.83014677735866), ['Peskin', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.83014677735866), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.05836799491756), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.05836799491756), ['Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.81995640157757), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.04537611459344), ['Breed', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.84728719266617), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.69592281226271), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.42447905201442), ['Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 6.75195265990951), ['Peskin', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 5.16961873630441), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.37787441842076), ['Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.4068419192282), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.25967856744616), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.27501507194877), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.58673649851208), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.81235999395141), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.77646037723009), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.91325750081675), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56137626161468), ['Safai', 'Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.17156378400377), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33014398314256), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.1670768877771), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30682670922094), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30306029158021), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30306029158021), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43048787618196), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43048787618196), ['Peskin', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30931771424639), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36536861333256), ['Breed', 'Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.35963307721112), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.46222461683487), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.46604332182081), ['Peskin', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33013021834909), ['Breed', 'Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33013021834909), ['Peskin', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33013021834909), ['Peskin', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.46893987932092), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.32607774103613), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.46318345922829), ['Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.59052033013027), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47862229272664), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.61020355687905), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.55841264236369), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.71192960661188), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.13848759301728), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51315838400248), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51315838400248), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51315838400248), ['Safai', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51315838400248), ['Lurie', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51315838400248), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51315838400248), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.65423419660784), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.50685916450199), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.50685916450199), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.50685916450199), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36871881223184), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36871881223184), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36871881223184), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36871881223184), ['Lurie', 'Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52375379683817), ['Lurie', 'Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51732451450868), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.77906073371605), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60356684905042), ['Breed', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.80644027126598), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 3.47154334873613), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 2.31159615551385), ['Lurie', 'Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.92930389695465), ['Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.92930389695465), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.92930389695465), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.92930389695465), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.13984415500226), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 2.09818619272353), ['Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 3.79977363454743), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 2.18159828714142), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 2.54528901518284), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.58983315163238), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.29366614921349), ['Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.73815640936687), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.85800930389133), ['Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.09389039546646), ['Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.7192803296924), ['Breed', 'Safai', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.55292262644516), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.65033677284824), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.65033677284824), ['Lurie', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.13269676689862), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.78762165325775), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.78762165325775), ['Breed', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.11879247188052), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.11879247188052), ['Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.34114507667992), ['Peskin', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51532958193696), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.62411469602155), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.64491769035086), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.75243087722534), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.75243087722534), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.75243087722534), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52139049920199), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36254932385722), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51499022727361), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47861770858648), ['Peskin', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47861770858648), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47861770858648), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.67986181824794), ['Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.4727424893614), ['Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.85612728423976), ['Lurie', 'Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.85612728423976), ['Farrell', 'Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.79964016611997), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.01947460660476), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.7439691256421), ['Breed', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.73483661417955), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.95619915360293), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.12947025899518), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.12947025899518), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 3.66510422853457), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 3.31380125069861), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 6.61681954770185), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 7.87929508794732), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.35992147026345), ['Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.543442026646), ['Breed', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.18650376752818), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.6471296459374), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.6471296459374), ['Peskin', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.90088877297496), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.90088877297496), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.49135270248555), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.0596077449), ['Breed', 'Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.2832889645587), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60663362595334), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.3082123800791), ['Safai', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.7695456194895), ['Safai', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30700077366382), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.3655758889126), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.79101372307745), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.78130372081519), ['Safai', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60532823002518), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56538878660347), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30221593223795), ['Peskin', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.35987810959858), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.44126440044556), ['Safai', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.44126440044556), ['Breed', 'Safai', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.61910833989921), ['Breed', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43358230022403), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.7852089573896), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.32921043921018), ['Safai', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.3920231128973), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.7099460923374), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47477846123192), ['Safai', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47477846123192), ['Peskin', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.46895037026695), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.46895037026695), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.8492598316733), ['Breed', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.8492598316733), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.65770809914181), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.42898878081624), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.42898878081624), ['Safai', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.74858657709139), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.73800135335483), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51316986418821), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.68091459837492), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.69991015206562), ['Farrell', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.83345156739094), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.16641041009584), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.41493986183681), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.77649513511462), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.50025030051023), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.65300338588518), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.43343100517006), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.56859582780061), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.37976641588348), ['Farrell', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.19351704139234), ['Lurie', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60217358756284), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.23648559295952), ['Lurie', 'Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33592055273869), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.460797914822), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.35699700095459), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.19306949297704), ['Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.27445910980283), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.56923431732359), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.72572634080556), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.86419343176576), ['Breed', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.46970550816879), ['Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30305430330865), ['Safai', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43117274744031), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.43117274744031), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.61246770187309), ['Safai', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.1831222081517), ['Peskin', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.67022010711061), ['Lurie', 'Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.67022010711061), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.8439857993823), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.79809672301466), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 3.86145470770481), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 4.22556908696709), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.30413004017039), ['Peskin', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.44405918258342), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.80418238381835), ['Lurie', 'Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.79431073110446), ['Lurie', 'Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.18997575996047), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.24099391730391), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.09614156352375), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.35187435567231), ['Safai', 'Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.34755496058481), ['Safai', 'Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.34755496058481), ['Lurie', 'Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.48268249159277), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.37395178313356), ['Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.31738465126714), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.31348863076598), ['Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.40010515200001), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.2916635161805), ['Farrell', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52819685058717), ['Lurie', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.84964530655754), ['Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.84964530655754), ['Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.79130842588661), ['Breed', 'Safai', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.98584350166649), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.8778695000081), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.52554842061656), ['Lurie', 'Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 1.21486971772277), ['Peskin', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.06895469354959), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.63588739149075), ['Safai', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.14226249472281), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51014202415164), ['Breed', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.29634239845065), ['Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.29634239845065), ['Peskin', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.29634239845065), ['Breed', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.65361391990568), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.83330330578625), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.91187931894475), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 4.01839692905883), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.48976646642776), ['Lurie', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.6451714760417), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.38331302345488), ['Farrell', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.57541326979239), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.75962900095423), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.70439924029511), ['Breed', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.99531496471127), ['Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.46089264544554), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.79962034774766), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 3.02218182857535), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.03425273726002), ['Safai', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.85001927693605), ['Breed', 'Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.61982351857904), ['Safai', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.62832821231172), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.13788994669026), ['Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.70339099318572), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.75681358625782), ['Lurie', 'Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 3.15929498970377), ['Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 2.93616159810623), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.57009956850199), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.80980900261464), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.81638352248057), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.67887339186978), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.61339866893648), ['Lurie', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 7.55431062922739), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.91945176518954), ['Safai', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.90816513581819), ['Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.01376684594302), ['Safai', 'Peskin', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60850364229768), ['Peskin', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33133574383241), ['Breed', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.70229195320634), ['Safai', 'Farrell', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.68139565490654), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.93421556496531), ['Breed', 'Safai', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 1.6630743198083), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 1.31959613389611), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 2.34732954629559), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.72721738271712), ['Peskin', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.75658586095923), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.2686159770258), ['Lurie', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.88954890750978), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.53318602994077), ['Peskin', 'Farrell', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.75737444995609), ['Farrell', 'Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.52664096326761), ['Farrell', 'Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.63491682618632), ['Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.66253964766051), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 3.36275887972702), ['Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.62566759318526), ['Peskin', 'Safai', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.89042784299609), ['Breed', 'Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.45873108646911), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.45873108646911), ['Breed', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.32961125962212), ['Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 1.57441058417827), ['Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.54025751791974), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.65211196077555), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.83138843299946), ['Peskin', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.54667391602365), ['Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.89453244020351), ['Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.99104752621656), ['Farrell', 'Lurie', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 4.4236630228601), ['Breed', 'Safai', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.5203129629033), ['Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.5203129629033), ['Peskin', 'Breed', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.61198192474259), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.33675760531997), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.36811298512964), ['Farrell', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.66664532455746), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51647451933316), ['Lurie', 'Peskin', 'Safai']),
    new Ballot(Math.round(SCALE_FACTOR * 0.47754943339382), ['Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.48051750380316), ['Peskin', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60509964601461), ['Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.60509964601461), ['Peskin', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 1.67906035753438), ['Breed', 'Peskin', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 2.02427032368784), ['Farrell', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.6772210099221), ['Lurie', 'Farrell', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.59167922141412), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.48992362122938), ['Breed', 'Lurie', 'Farrell']),
    new Ballot(Math.round(SCALE_FACTOR * 0.31500373180405), ['Peskin', 'Safai', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.44817388505311), ['Farrell', 'Lurie', 'Breed']),
    new Ballot(Math.round(SCALE_FACTOR * 0.81163402848772), ['Safai', 'Breed', 'Lurie']),
    new Ballot(Math.round(SCALE_FACTOR * 0.51421747109197), ['Breed', 'Safai', 'Peskin']),
    new Ballot(Math.round(SCALE_FACTOR * 0.48052825375945), ['Breed', 'Lurie', 'Safai']),
  ],
  0
);
// 18% undecided
bs.undervotes = Math.round(bs.totalVotes / (1 - 0.18) - bs.totalVotes);
const SimpleWeightedMayor0722 = new SimpleScenario({
  name: 'Simple Mayor 0524',
  notes: 'These are the raw (but weighted) ballots from FM3.',
  ballotSet: bs,
});

export { Mayor0722, SimpleWeightedMayor0722 };
